/**
 * @license
 */
import { Action } from '@ngrx/store';

// Model
import { UIHeader } from '@api/models';

// Actions
export const SET_BACKGROUND = '[UI Header] Set background';
export const SET_COLOR = '[UI Header] Set color';

/**
 * 
 */
export class SetBackgroundAction implements Action {
    readonly type = SET_BACKGROUND;
    constructor(public payload: string) { }
}

/**
 * 
 */
export class SetColorAction implements Action {
    readonly type = SET_COLOR;
    constructor(public payload: string) { }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/actions/ui-header/ui-header.actions.ts